export default __webpack_public_path__ + "static/media/PH-A538.7a3d1d8b.webp";